module.exports = __webpack_public_path__ + "img/upgrade_member.e78b78da.svg";